import React, {useContext, useEffect, useState} from 'react';
// @ts-ignore
import { Container, Row } from 'shards-react';

import LayoutHeader from "./MainHeader/LayoutHeader";
import './DefaultLayoutStyle.css'
import SplashContainer from "../home/SplashContainer";
import {GlobalDataContext} from "../../contexts/GlobalDataContext";
import styled from 'styled-components';

const Hideable = styled.div`
display: block;

@media (max-width: 480px) {
  display: none;
}
`;

const FullContent: React.FC = ({ children }) => {
    return (
        <Container fluid className='mainContainerDefaultLayout' id="ContainerFLUIDO">
            <LayoutHeader/>
            <Row id='CONTENT' className='contentContainerDefaultLayout'>
                <div id='SUBCONTENT' style={{height: '100%', width: '100%'}}>
                    { children }
                </div>
            </Row>
        </Container>
    )
};

const DefaultLayout: React.FC = ({ children }) => {
    // @ts-ignore
    const { allDataLoaded } = useContext(GlobalDataContext);

    const [show, setShow] = useState(false);
    const [showSplash, setShowSplash] = useState(true);

    useEffect(() => {
      setShow(allDataLoaded);

      if (allDataLoaded) {
        const timer = setTimeout(() => {
          setShowSplash(false);
        }, 3000);
        return () => clearTimeout(timer);
      }
    }, [allDataLoaded]);

    return (
        <>
        {
            (showSplash) ?
                <Hideable>
                  <SplashContainer show={show}/>
                </Hideable> :
                <FullContent children={children}/>
        }
        </>
    )
};

export default DefaultLayout;
